import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { InviteModel } from '../../../../../../common/dist/angular/models/invite.model';
import { EmployeeModel } from '../../../../../../common/dist/angular/models/employee.model';
import { InviteCreationOptions } from '../../../../../../common/src/options/invite-creation.options';
import { TransformerClassType } from '../../../../modules/src/lib/core/interceptors/transformer.http-interceptor';
import { BaseApiController } from './base.api-controller';
import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';

@Injectable()
export class EmployeeApiController extends BaseApiController {
  constructor(private readonly httpClient: HttpClient,
              environmentManager: EnvironmentManager) {
    super(environmentManager);
  }

  public async create(options: InviteCreationOptions): Promise<InviteModel> {
    return this.httpClient.post<InviteModel>(`${this.getApiUrl()}/api/employees`, options, {
      context: new HttpContext().set(TransformerClassType, InviteModel),
    }).toPromise();
  }

  public async listForOrganization(): Promise<EmployeeModel[]> {
    return this.httpClient.get<EmployeeModel[]>(`${this.getApiUrl()}/api/employees`, {
      context: new HttpContext().set(TransformerClassType, EmployeeModel),
    })
      .toPromise();
  }

}
